import React from "react";
import { DataTable, SaveTable, Row } from "../DataTable.jsx";
import { ButtonGroup, Button } from "bootstrap-micro";
import { testRelayConnection } from "../store/relaysSlice.js";

export class RelayConfiguration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            verifying: false,
            verificationInfo: null,
            verificationError: null
        };
    }
    render() {
        let { value, onChange, disabled, onSave } = this.props;
        let inpBind = key => ({
            value: value[key],
            onChange: ev => onChange(Object.assign({}, value, { [key]: ev.target.value }))
        });

        return <SaveTable
            disabled={disabled}
            onSave={onSave}
            postSaveEntries={this.props.onRemove ? <Row label=""><Button bsStyle="danger" className="btn-block" onClick={this.props.onRemove}>Remove Relay</Button></Row> : null} >

            <Row label="IP Address / DNS (*)">
                <input
                    type="text"
                    {...inpBind("host")}
                    autoComplete="off"
                    required
                    id="host"
                    name="host"
                    className="form-control"
                    placeholder="e.g. 86.32.46.231 or my-comp.dyndns.org"
                    title="To View On Panel - Go to User > Network > Cloud. MAC Address in bottom right."
                />
            </Row>
            <Row label="Port (*)">
                <input
                    type="number"
                    {...inpBind("port")}
                    autoComplete="off"
                    required
                    name="port"
                    className="form-control"
                    title="Please enter the panel's engineer password"
                    min="1"
                    max="65535"
                    step="1"
                />
            </Row>
            <Row label="Password (*)">
                <input
                    type="text"
                    className="form-control" {...inpBind("password")}
                    required
                    minLength="32"
                    maxLength="32"
                />
            </Row>
            <Row label="">
                <Button bsStyle="info" type="button" disabled={this.state.verifying} onClick={() => {
                    this.setState({ verifying: true, verificationInfo: null, verificationError: null })
                    testRelayConnection(value.host, value.port, value.password)
                        .then(({ status }) => this.setState({ verificationInfo: status }), err => this.setState({ verificationError: err }))
                        .then(() => this.setState({ verifying: false }))
                }}>Verify Connection</Button>
            </Row>
            <Row label="Relay Info" noParagraph>
                {this.state.verificationInfo ?
                    <table className="table table-striped">
                        <tbody>
                            <tr><th>Module ID: </th><td>{this.state.verificationInfo.moduleID}</td></tr>
                            <tr><th>System Firmware: </th><td>{this.state.verificationInfo.systemFirmwareMajor}.{this.state.verificationInfo.systemFirmwareMinor}</td></tr>
                            <tr><th>App Firmware: </th><td>{this.state.verificationInfo.applicationFirmwareMajor}.{this.state.verificationInfo.applicationFirmwareMinor}</td></tr>
                            <tr><th>Voltage: </th><td>{this.state.verificationInfo.voltage}</td></tr>
                            <tr><th>Temp: </th><td>{this.state.verificationInfo.temp}</td></tr>
                        </tbody>
                    </table>
                    : <p>{this.state.verificationError ? "" + this.state.verificationError : (this.state.verifying ? "Connecting to relay" : "Waiting to verify")}</p>
                }
            </Row>

            <Row label="Relay Nickname">
                <input
                    type="text"
                    className="form-control" {...inpBind("name")}
                    placeholder="Office relay"
                />
            </Row>
            <Row label="">
                <small>(*) Denotes a required field.</small>
            </Row>

        </SaveTable >
    }
}


export const RelayActionConfiguration = props => {
    let { value, onChange, disabled } = props;
    let inpBind = key => ({
        value: value[key],
        onChange: ev => onChange(Object.assign({}, value, { [key]: ev.target.value }))
    });

    return < DataTable style={{ "marginLeft": "0px" }} disabled={disabled} >

        <Row label="Trigger Relay 1 For ">
            <input
                type="number"
                {...inpBind("relay_1")}
                required
                className="form-control"
                min="0"
                step="1"
                style={{ maxWidth: "100px" }}
            /> seconds
        </Row>

        <Row label="Trigger Relay 2 For ">
            <input
                type="number"
                {...inpBind("relay_2")}
                required
                className="form-control"
                min="0"
                step="1"
                style={{ maxWidth: "100px" }}
            /> seconds
        </Row>

        <Row label="Switch The Following I/O Ports On" noParagraph>
            <ButtonGroup>
                <Button onClick={() => onChange(Object.assign({}, value, { io_1: !value.io_1 }))} bsStyle={value.io_1 ? "primary" : null} type="button">1</Button>
                <Button onClick={() => onChange(Object.assign({}, value, { io_2: !value.io_2 }))} bsStyle={value.io_2 ? "primary" : null} type="button">2</Button>
                <Button onClick={() => onChange(Object.assign({}, value, { io_3: !value.io_3 }))} bsStyle={value.io_3 ? "primary" : null} type="button">3</Button>
                <Button onClick={() => onChange(Object.assign({}, value, { io_4: !value.io_4 }))} bsStyle={value.io_4 ? "primary" : null} type="button">4</Button>
            </ButtonGroup>
        </Row>

    </DataTable >
}